<div fxLayout="column" fxLayoutAlign="start" *screenResource="['BRIEVEN', 'READ']">
  <div class="page-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
    <div fxFlex class="mat-display-1 page-title">Brievenplanning</div>
    <div fxFlex="1 1 auto" class="generic-search-field" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>search</mat-icon>
      <input #input matInput [(ngModel)]="filterText" (keyup)="applyFilter()" placeholder="Zoeken" />
      <button [ngClass]="{'isHidden': filterText === ''}" mat-icon-button matTooltip="Zoekopdracht verwijderen" (click)="removeFilter()"><mat-icon>close</mat-icon></button>
    </div>
    <div fxFlex></div>
  </div>

  <div class="page-content">
    <div class="table-responsive" *appSkeletonLoader="{ loading: loading, amountOfRows: 10, height: '32px', minWidth:'20%', maxWidth: '90%' }">
      <table fxFlexFill mat-table [dataSource]="dataSource" matSort matSortActive="SendDate" matSortDirection="asc">
        <ng-container matColumnDef="SendDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Verzenddatum</th>
          <td mat-cell *matCellDef="let entry">{{ entry.SendDate | date: "dd/MM/yyyy"  }}</td>
        </ng-container>
        <ng-container matColumnDef="Type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
          <td mat-cell *matCellDef="let entry">
            <span [innerHTML]="entry.TypeDescription | highlightDossier:filterText"></span>
          </td>
        </ng-container>
        <ng-container matColumnDef="ContextBuilding">
          <th mat-header-cell *matHeaderCellDef>Dossier</th>
          <td mat-cell *matCellDef="let entry">
            <a [href]="entry.DossierUrl" [innerHTML]="entry.ContextBuildingCode | highlightDossier:filterText"></a>
          </td>
        </ng-container>
        <ng-container matColumnDef="ContextInfo">
          <th mat-header-cell *matHeaderCellDef>Context</th>
          <td mat-cell *matCellDef="let entry">
            <a [href]="entry.ContextUrl" [innerHTML]="entry.ContextDescription | highlightDossier:filterText"></a>
          </td>
        </ng-container>
        <ng-container matColumnDef="LastAttemptDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum laatste verzendpoging</th>
          <td mat-cell *matCellDef="let entry">{{ entry.LastSendAttemptDate ? (entry.LastSendAttemptDate | date: "dd/MM/yyyy HH:mm:ss") : "-" }}</td>
        </ng-container>
        <ng-container matColumnDef="LastAttemptError">
          <th mat-header-cell *matHeaderCellDef>Fout laatste verzendpoging</th>
          <td mat-cell *matCellDef="let entry">{{ entry.LastSendError ?? "-" }}</td>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let entry">
            <div fxLayout="row" fxLayoutAlign="end center">
              <button type="button" mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <ng-container *screenResource="['BRIEVEN', 'UPDATE']">
                  <button mat-menu-item type="button" (click)="sendItem(entry)">
                    <mat-icon>send</mat-icon>
                    <span>Nu versturen</span>
                  </button>
                </ng-container>
                <ng-container *screenResource="['SHAREPOINT', 'READ']">
                  <button type="button" mat-menu-item *ngIf="entry.SharepointUrl" (click)="openUrl(entry.SharepointUrl)">
                    <mat-icon>launch</mat-icon>
                    <span>Open in SharePoint</span>
                  </button>
                </ng-container>
                <ng-container *screenResource="['BRIEVEN', 'UPDATE']">
                  <button mat-menu-item type="button" (click)="cancelItem(entry)">
                    <mat-icon>cancel</mat-icon>
                    <span>Geplande verzending annuleren</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr 
          mat-row
          *matRowDef="let entry; columns: displayedColumns"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td *ngIf="loading" class="mat-cell" [attr.colspan]="displayedColumns.length">Laden...</td>
          <td *ngIf="!loading" class="mat-cell" [attr.colspan]="displayedColumns.length">Geen gegevens gevonden.</td>
        </tr>
      </table>
      <mat-paginator [style.display]="loading ? 'none' : 'unset'" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
